var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useRef } from 'react';
import { useBreakpoint } from '../../../../util/Breakpoint.context';
import FormControl from '../../../FormControl/FormControl.context';
import FormLabel from '../../../FormLabel/FormLabel';
import Icon from '../../../Icons/Icon';
import * as Styled from './SearchInput.styled';
/**
 * SearchInput Component
 */
var SearchInput = function (_a) {
    var id = _a.id, name = _a.name, className = _a.className, onRequestClose = _a.onRequestClose, query = _a.query, refine = _a.refine, inputProps = __rest(_a, ["id", "name", "className", "onRequestClose", "query", "refine"]);
    var large = useBreakpoint().large;
    var label = large ? 'Search' : 'Search Bombas';
    var inputFieldRef = useRef(null);
    useEffect(function () {
        var _a;
        (_a = inputFieldRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }, []);
    return (React.createElement(FormControl, { id: id, name: name, containerClass: className },
        React.createElement(FormLabel, { htmlFor: id, disabled: inputProps.disabled }, label),
        React.createElement(Styled.Input, __assign({ id: id, type: "text", value: query, onChange: function (e) {
                return refine(e.currentTarget.value);
            }, ref: inputFieldRef, onKeyUp: function (e) {
                var ESC_KEY = 27;
                var keyCode = e.keyCode;
                if (keyCode === ESC_KEY) {
                    onRequestClose();
                }
            } }, inputProps)),
        React.createElement(Styled.IconContainer, { "data-testid": "x_icon", onClick: onRequestClose },
            React.createElement(Icon, { name: "close" }))));
};
export default SearchInput;
